import { FunctionComponent, useEffect, useState } from 'react';
// import { useTheme } from '@mui/material/styles';
import { useAtom } from 'jotai';
// import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next'
import { useMutation, useQuery } from '@tanstack/react-query';

import { fetchAll, fetchAllWithCount, fetchOne } from '../../lib/v31lib';
import { loginAtom } from '../../lib/auth';
// import { checkAllowed } from '../../lib/permission';

import LaunchIcon from '@mui/icons-material/Launch';

// import {
//   CircularProgress
// } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';

import { AlertSomethingWentWrong } from '../../components/alerts/SomethingWentWrong';

import { getCookie, setCookie } from 'react-use-cookie';

import {
  DataGrid,
  Dt,
  Page,
  SearchBox,
  StyledButton,
  StyledIconButton,
  Typography
} from '../../components/interface';

import { Location } from '../../models';
import { useParams } from 'react-router-dom';
import Edit from '@mui/icons-material/Edit';
import { CircularProgress } from '@mui/material';
import DeleteForever from '@mui/icons-material/DeleteForever';
import { SnackDestroyed } from '../../components/snacks/Destroyed';
import AddCircleOutline from '@mui/icons-material/AddCircleOutline';

// const { DateTime } = require("luxon");

type Props = {};

export const AdminLocations: FunctionComponent<Props> = () => {
  // const theme = useTheme();
  // const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);

  const [login, setLogin] = useAtom(loginAtom);

  const params = useParams();
  const memoqSettingId: string | undefined = params.memoq_setting_id;

  const [page, setPage] = useState<number>(0);
  const [order, setOrder] = useState<string>("id DESC");
  const [serverErrorSnackOpen, setServerErrorSnackOpen] = useState<boolean>(false);
  const [activeCompany, setActiveCompany] = useState<string>(getCookie('cribeon_active_company_id') || '');
  let count = 0;
  const [destroyedOpen, setDestroyedOpen] = useState<boolean>(false);


  const {
    data: objects,
    isLoading: objectsLoading,
    // isError: bookYearsError,
    // isSuccess: bookYearsSuccess,
    refetch: objectsRefetch,
  } = useQuery({
    queryKey: ["memoq_locations", activeCompany, {page: page, order: order, memoq_setting_id: memoqSettingId}],
    queryFn: () =>
      fetchAllWithCount<Location>(
        "/nl/v3/objects/fetch_all",
        {
          object: "location",
          fields: [
            "id", 'name', 'current_nof_children', 'created_at', 'current_nof_workers'
          ],
          // sub_fields: {
          //   'company': ['id', 'name', 'get_item'],
          //   'user': ['id', 'first_name', 'last_name']
          // },
          order: order,
          page: page,
          per_page: 20,
          filter: {
            search: '',
            advanced: {
              memoq_setting_id: memoqSettingId
            }
          }
        },
        login
      ),
    select: (d) => {
      count = d.count;
      return d.result;
    },
    enabled: !!login && !!activeCompany && !!memoqSettingId
  });









  const mutationDestroy = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetchOne<Location>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/remove`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      setDestroyedOpen(true);
      objectsRefetch();
    },
  });


  







  const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID', width: 100, sortable: true },
    { field: 'name', headerName: 'Name', width: 200, sortable: false, renderCell: params => <>
      {params.row.name.nl || params.row.name.en || Object.values(params.row.name).filter(fff => !!fff)[0]}
    </> },
    { field: 'current_nof_children', headerName: '# ch.', width: 100, sortable: false },
    { field: 'current_nof_workers', headerName: '# wrk.', width: 100, sortable: false },
    { field: 'created_at', headerName: 'Time', width: 200, sortable: true, renderCell: params => <>
      {!!params.row?.created_at && <Dt d={params.row.created_at} f="d LLLL y - t" />}
    </> },
  ];

  return (
    <Page sx={{}} title={t("objects.memoq_locations.title")} actions={<>
      {!!activeCompany && !!memoqSettingId && <StyledButton
        label="Create new"
        id='create_new'
        contained
        path={`/location/${memoqSettingId}/new`}
        sx={{marginRight: 3}}
        startIcon={<AddCircleOutline />}
      />}
    </>}>
      {!activeCompany && <Typography>Select a company in the sidebar</Typography>}
      {!!activeCompany && <>
        <DataGrid
          action_count={2}
          actions={(params) => {
            return (<>
              <StyledIconButton title="Edit" color="primary" path={`/location/${memoqSettingId}/${params.row.id}`}>
                <Edit />
              </StyledIconButton>
              {!!mutationDestroy.isPending && <CircularProgress />}
              {!mutationDestroy.isPending && <StyledIconButton title="Destroy" destroyBtn color="primary" onClick={(e) => {
                mutationDestroy.mutate({
                  formData: {
                    object: 'location',
                    id: params.row.id,
                    ob: {
                      id: params.row.id,
                    }
                  }
                });
              }}>
                <DeleteForever />
              </StyledIconButton>}
            </>);
          }}
          getRowClassName={(params) => `datagrid-row-enabled-${params.row.enabled}`}
          objectCount={count}
          objects={(objects || []).map(u => ({
            ...u
          }))}
          columns={columns}
          loader={objectsLoading}
          onSortModelChange={(a, b) => {
            let a_0_field:string = a[0].field;
            setOrder([a_0_field, a[0].sort].join(' '));
          }}
          page={page}
          setPage={(p) => {setPage(p);}}
        />

        {!!serverErrorSnackOpen && <AlertSomethingWentWrong open={serverErrorSnackOpen} setOpen={(b) => {setServerErrorSnackOpen(b);}} />}
      </>}
   
      <SnackDestroyed open={destroyedOpen} setOpen={setDestroyedOpen} />
    </Page>
  );
}
